// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import addDays from "@insite/client-framework/Common/Utilities/addDays";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

export const getDateFromApi = (date: string) => {
    return date?.split(" ")?.[0];
};

export const getCartRequestedDate = (type: "deliveryDate" | "pickUpDate", cart?: CartModel) => {
    if (!cart) {
        return cart;
    }
    const cartRequestedDate = type === "deliveryDate" ? cart?.requestedDeliveryDate : cart?.requestedPickupDate;
    return cartRequestedDate ? getDateFromApi(cartRequestedDate) : cartRequestedDate;
};

export function isValidDate(blackOutDays: string[], currentDate: Date) {
    const todayDate = new Date();
    return (
        currentDate.getDay() !== 0 &&
        currentDate.getDay() !== 6 &&
        !blackOutDays.find((item: string) => new Date(item).toDateString() === currentDate.toDateString()) &&
        currentDate.getTime() > todayDate.getTime()
    );
}

export function getValidDate(blackOutDays: string[], currentDate: Date): Date {
    if (isValidDate(blackOutDays, currentDate)) {
        return currentDate;
    }
    return getValidDate(blackOutDays, addDays(currentDate, 1));
}
